import type { AssetEvent } from "@/entities/asset-event";
import type { Int } from "@/types";

import { useInfiniteListWrapper } from "@/hooks/queries";

import { DEFAULT_ASSET_EVENT_STALE_TIME } from "./constants";
import { fetchAssetEvents, getQueryKey } from "./helpers";

export const useGetAssetEventInfiniteList = (assetId: Int, params?: object) => {
  const queryKey = getQueryKey(assetId, params, true);

  const queryFn = ({ pageParam = 1 }) => {
    const queryParams = { ...params, ["page[number]"]: pageParam };
    return fetchAssetEvents(assetId, queryParams);
  };

  const { data, ...queryResult } = useInfiniteListWrapper({
    queryKey,
    queryFn,
    staleTime: DEFAULT_ASSET_EVENT_STALE_TIME,
  });

  return {
    assetEvents: (data ?? []) as AssetEvent[],
    ...queryResult,
  };
};
